import {ReactElement} from "react";
import {useTabs} from "./TabsProvider";
import {RoleName} from "../../../administration/users/Role";

export function ContentTab(props: {
  tabIndex: number,
  component: ReactElement,
  visibleForRoles?: RoleName[]
}): ReactElement | null {
  const {selectedTab} = useTabs()
  if (props.tabIndex !== selectedTab) {
    return null;
  }
  return props.component;
}
